import "./ProjectHeroCrisisConnect.scss";

function ProjectHeroCrisisConnect() {
  return (
    <>
      <section class="project-cs-hero">
        <div class="project-cs-hero__content">
          <h1 class="heading-primary">Crisis Connect</h1>
          <div class="project-cs-hero__info">
            <p class="text-primary text-primary--project">
              An interactive platform tailored for BC's natural disaster
              survivors, facilitating direct connections with their community
              for personalized, one-on-one support beyond governmental aid. This
              platform not only encourages real-time interaction and firsthand
              information sharing but also links affected individuals directly
              to emergency services and vital resources.
            </p>
          </div>
          <div class="project-cs-hero__cta">
            <a
              href="https://supreet-kaur-crisis-connect.netlify.app/"
              class="btn btn--bg"
              target="_blank"
              rel="noreferrer"
            >
              Live Link
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default ProjectHeroCrisisConnect;
